import api from "../../../../helpers/api"

export const getMySupplierPrivateInquiry = (body) => api.post('private-supplier-inquiry/get-single-private-supplier-inquiry/' , {...body})


export const getMySupplierPrivateInquiries = (body) => api.post('private-supplier-inquiry/search-private-suppliers-sinquiries/', body)


export const addProposalBySupplier = (body) => api.post(`private-supplier-inquiry/add-private-supplier-proposal`, {...body})

export const addStagingProposalBySupplier = (body) => api.post(`private-supplier-staging-proposals/create`, {...body})

export const editProposalBySupplier = (body) => api.post(`private-supplier-inquiry/edit-private-supplier-proposal`, {...body})

export const editStagingProposalBySupplier = (body) => api.post(`private-supplier-staging-proposals/update`, {...body})